'use strict';

export default {
  fields: {
    fieldErrors: {
      email: "Le format du courriel n'est pas valide",
      date: "La date n'est pas valide",
      time: "L'heure n'est pas valide",
      pastDate: 'La date doit être dans le passé',
      requireCheck: 'Le champs doit être coché',
      requiredField: 'Ce champs est obligatoire',
      minMax: 'Ce champ doit être compris entre {min} et {max}',
      limit: `{quantityLeft, plural, 
        =0 {Il ne reste plus de {product}} 
        other {Il ne reste que {quantityLeft} {product}}
      }`,
    },
  },
};
